import { LoginPage as LoginPageView } from "../components/LoginPage";

/** Route entry for the login page */
export function LoginPage() {
  return <LoginPageView />;
}
